/** Same gate as `Bugsnag.start()` in `src/index.js` — only call `Bugsnag.notify` when this is true. */
const bugsnagKey = process.env.REACT_APP_BUGSNAG_KEY;
const bugsnagEnabled = Boolean(bugsnagKey) && bugsnagKey !== 'undefined' && bugsnagKey !== 'null';

export default bugsnagEnabled;
